import Vue from "vue";
import VueRouter from "vue-router";
import api from '@/utils/api'
import {Toast} from "vant"; 
import store from '@/store'
import { stringifyQuery, parseQuery } from '@/utils/query'
Vue.use(VueRouter);  
// 路由
const routes = [
  {path:"", redirect:{name:'home'}},
  {path: "/404", name: '404', component: () => import("@/views/404.vue"), meta: { index: 1 } },
  {path:"/unauthorized",name:'unauthorized',component:()=>import("@/views/unauthorized.vue"), meta: { index: 1.1 }},
  {path:"/mall/phone/home/payment",name:'paymentSuccess',component:()=>import("@/views/PaymentSuccess.vue"), meta: { index: 2 }},
  {path:"/mall/phone/login",name: 'login', component: () => import("@/views/Login.vue"), meta: { index: 13 } },
  {path:"/mall/phone/nonsupport",name:'nonsupport',component:()=>import("@/views/Nonsupport.vue"), meta: { index: 6 }},
  {path: "/mall/phone/personal", name: 'personal', component: () => import("@/views/Personal.vue"), meta: { index: 7 } },
  {path: "/mall/phone/coupon", name: 'coupon', component: () => import("@/views/Coupon.vue"), meta: { index: 71 } },
  {path: "/mall/phone/couponList", name: 'couponList', component: () => import("@/views/CouponList.vue"), meta: { index: 72 } },
  {path: "/mall/phone/focus", name: 'focus', component: () => import("@/views/Focus.vue"), meta: { index: 73 } },
  {path:"/mall/phone/mobile",name:'mobile',component:()=>import("@/views/Mobile.vue"), meta: { index: 12 }},
  {path:"/mall/phone/orderform",name:'orderForm',component:()=>import("@/views/OrderForm.vue"), meta: { index: 9 }},
  {path: '/mall/phone/inventory',name:'inventory', component: () => import("@/views/inventory/index.vue"),meta: { index: 5 }},
  {path: '/mall/phone/recharge',name:'recharge',component: () => import("@/views/recharge/index.vue"),meta: { index: 8}},
  {path: '/mall/phone/rechargeDetails',name:'rechargeDetails', component: () => import("@/views/rechargeDetails/index.vue"), meta: { index: 11 } },
  {path: "/mall/phone/pay", name: 'pay', component: () => import("@/views/Pay.vue"), meta: { index: 0 } },
  {path: "/mall/phone/lottery", name: 'lottery', component: () => import("@/views/Lottery.vue"), meta: { index: 74 } },
  {path:"/",component:()=>import("@/views/Index.vue"), redirect:{name:'home' },
    children:[
      {path:"",redirect:{name:"home"}},
      {path:"/mall/phone/home",name:"home",component:()=>import("@/views/Home.vue"),meta: { index: 4 }},
      {path: "/mall/phone/home/good/detail", name: "goodDetails", component: () => import("@/views/GoodDetails.vue"), meta: { index: 42 } },
      {path: "**", redirect: { name: 'home' } },
    ]
  },
  {path:"**", redirect:{name:'home'}}
]
const router = new VueRouter({
  routes,
  mode: "history",
  stringifyQuery, // 序列化query参数
  parseQuery,
  base:process.env.BASE_URL
})
router.beforeEach((to, from, next) => {
  let deviceNum = to.query.deviceNum

  // const  userInfo= {"deviceCode":"861197060005446","deviceNum":"AA000003","userId":21,"appId":"wxe5c3868d53cab507","nickname":"ð","avatar":"https://weiding-robot.oss-cn-hangzhou.aliyuncs.com/85fd8c86374f4287bcf53c0687325f14.png","sex":"男","money":9919.73,"phone":"","openId":"o9LBW55kDNgRP7KebLX3o3seu_aw","unionId":"ohlSD1m9J70w7caEEQQY-KI9mcnY","cmsUerName":"杭州维丁科技有限公司","storeId":110,"cmsUserId":3,"deviceAddress":"金蓬街366号2楼","manager":true,"token":".eJxNkG9PwyAQxr-K6WtNYJSj-K66vZhbGuefzCUkpsJtNpOylNbFGL-7UKIbb56747nfHWTfKnMHbBujsuuLEMvlzZrz_bTaPdyLBb4tX5hjHofX-qiyy-AYPHbz0T2hMTf42WhMFSphtLSNOxHfPx6n1Mo7QY5C17PZarW5Wsyl1e0mEXu3x_bp64Aj9MQsjenQ-4RRapDU0CBFjjpKwQUDCBFnWzEJClLoREz9t85gai6AUikIEEJ4nsO5qRps8pQliYelS239c3hoVVv8nw8CTBxnAlYNArd5kBxJXErIcTeYFGR0EhkXBh4zTkGnNYsE973r_n6MkrNxqcZixdZtvcMu5n034E_2Cx0cf90.Z0KdRw.x7uwamYCjxSVN911eDIKa8AwGas","first":false,"coupons":[]}
  // let tokens =".eJxNkG9PwyAQxr-K6WtNYJSj-K66vZhbGuefzCUkpsJtNpOylNbFGL-7UKIbb56747nfHWTfKnMHbBujsuuLEMvlzZrz_bTaPdyLBb4tX5hjHofX-qiyy-AYPHbz0T2hMTf42WhMFSphtLSNOxHfPx6n1Mo7QY5C17PZarW5Wsyl1e0mEXu3x_bp64Aj9MQsjenQ-4RRapDU0CBFjjpKwQUDCBFnWzEJClLoREz9t85gai6AUikIEEJ4nsO5qRps8pQliYelS239c3hoVVv8nw8CTBxnAlYNArd5kBxJXErIcTeYFGR0EhkXBh4zTkGnNYsE973r_n6MkrNxqcZixdZtvcMu5n034E_2Cx0cf90.Z0KdRw.x7uwamYCjxSVN911eDIKa8AwGas"
  // localStorage.setItem('accessToken', tokens);
  // localStorage.setItem('userInfo', JSON.stringify(userInfo));
  // localStorage.setItem('accessOpenId', 'o9LBW55kDNgRP7KebLX3o3seu_aw');
  
  let deviceNumBackups = localStorage.getItem('deviceNum') ? localStorage.getItem('deviceNum') : ''
  let token = localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : ''
  let openId = localStorage.getItem('accessOpenId') ? localStorage.getItem('accessOpenId') : ''
  const whiteList = ['404', 'login',  'goodDetails','paymentSuccess',"pay"] 
  let loginType = browserJudgment()
  
  if (to.name=="login") {
    document.title = loginType==2?"微信授权":"支付宝授权"
  }
  if (to.name=="pay") {
    document.title = "支付"
  }
  if(loginType!=2&&loginType!=1){
    if (whiteList.indexOf(to.name) !== -1) {
      next()
    } else {
      store.commit('setMsg', '您访问的网址路径不正确，请重新扫描机器二维码进行访问！！')
      next({ name: '404' })
      return false
    }
  }
  if (!deviceNum) {
    if(!deviceNumBackups){
      if(to.name!='404'){
        store.commit('setMsg', '您访问的机器不存在，请重新扫描机器二维码进行访问！')
        next({ name: '404' })
        return false
      }
    }else{
      deviceNum=deviceNumBackups
    }
  } else {
     localStorage.setItem('deviceNum', deviceNum)
  }
  if(loginType==2&&deviceNum){
    let code = to.query.code
    if (code && !token) { //登陆之后获取到code，传到后台登录
      if (to.name!="pay") {
        loginApi(code,deviceNum,loginType,to.name)
      }
    } else if (token) { //已登录，有token，判断是否过期
      if(!store.state.personal.moneyApi){
        store.dispatch('getUserMoney')
      }
      let tokenData={
        token,
        deviceNum,
        openId
      }
      if (to.name!="pay") {
        api.login.isTokenClass(tokenData).then(res => {
          if (res.code == 401) {
            // Toast('登录失效，请重新授权登录！');
            // Toast(`错误：${res.msg} token：${token} deviceNum：${deviceNum} openId：${openId}`);
            Toast(res.msg);
            store.dispatch('submitDelUserInfo');
            router.push({name:'home'})
          } else if (res.code == 403) {
            Toast(res.msg);
            store.commit('setMsg', res.msg)
            store.dispatch('submitDelUserInfo');
            router.push({name:'404'})
          }
        })
      }
    } 
  }
  next()
})
function loginApi(code,deviceNum,loginType,name) {
  let data = {
    code: code,
    deviceNum:deviceNum
  }
  if(loginType==2){
    api.login.weixinLogin(data).then(res => {
      if(res.code==200){
        store.dispatch('submitChangeInfo',res)
        window.setTimeout(() => {
          // if (name != 'home') {
          //   router.push({name:'home'})
          // }
          Toast(res.msg);
        },1000);
      } else {
        store.dispatch('submitDelUserInfo');
        Toast(res.msg);
      }
    })
  }else if(loginType==1){
    api.login.alipayLogin(data).then(res => {
      if(res.code==200){
        store.dispatch('submitChangeInfo',res)
        window.setTimeout(()=>{
          router.push({name:'home'})
          Toast(res.msg);
        },3000);
      } else {
        store.dispatch('submitDelUserInfo');
        Toast(res.msg);
      }
    })
  }
}
function browserJudgment(){
  let type = ""
   var ua = window.navigator.userAgent.toLowerCase(); 
  if (ua.match(/MicroMessenger/i) == 'micromessenger'){ 
    type=2
  } else if(ua.match(/Alipay/i)=="alipay"){ 
   type=1
  }else{ 
   type=3
  }
  localStorage.setItem('loginType', type)
  return type
}

export default router;